export default {
  aigc_text2sql_title: 'Text2SQL',
  // 聊天框内的文本
  aigc_text2sql_chat_input_placeholder: 'Please enter the query for generating SQL.',
  aigc_text2sql_first_message:
    'Hello! Welcome to Text2SQL~\n' +
    'You can send the task to Text2SQL, let it select relevant tables and further generate SQL for you.\n' +
    'For example:',
  aigc_text2sql_question_one: 'Newly registered men in the last week',
  aigc_text2sql_question_two: 'How many iOS users are there',
  aigc_text2sql_generate_sql: 'Generate SQL based on relevant tables',
  aigc_text2sql_generate_sql_again: 'SQL Generate SQL based on relevant tables',
  aigc_text2sql_generate_table: 'Generate relevant table again',
  aigc_text2sql_chat_loading: 'Generating Revelant Table...',
  aigc_text2sql_sql_loading: 'Generating SQL...',
  aigc_text2sql_chat_stop: 'Stop',
  aigc_text2sql_chat_clear: 'Clear',

  // 表格内的文本
  aigc_text2sql_table_rebuild: 'Rebuild Table',
  aigc_text2sql_relevant_table: 'Relevant table',
  aigc_text2sql_table_edit_relevant: 'Edit relevant table',
  aigc_text2sql_table_database: 'Database',
  aigc_text2sql_table: 'Table',
  aigc_text2sql_table_column_name: 'Column Name',
  aigc_text2sql_table_data_type: 'Database',
  aigc_text2sql_table_description: 'Description',
  aigc_text2sql_table_operation: 'Operation',
  aigc_text2sql_table_details: 'Details',
  aigc_text2sql_table_delete: 'Delete',
  aigc_text2sql_table_total: 'tables was selected',



  // SQL结果内的文本
  aigc_text2sql_sql_title: 'How to use Text2SQL',
  aigc_text2sql_sql_result_title: 'Result',
  aigc_text2sql_sql_error: 'No results were found for the question from the selected table.',
  aigc_text2sql_sql_rebuild: 'Rebuild SQL',
  aigc_text2sql_sql_change: 'The data source has been modified. Please regenerate the SQL',
  aigc_text2sql_sql_copy: 'Copy SQL',
  aigc_text2sql_sql_copied: 'Copied',
  aigc_text2sql_sql_edit: 'Edit SQL',
  aigc_text2sql_sql_save: 'Save',
  aigc_text2sql_sql_save_success: 'Save Success',
  aigc_text2sql_sql_cancel: 'Cancel',
  aigc_text2sql_feedback_title: 'Feedback',
  aigc_text2sql_feedback_placeholder: 'Leave your feedback',
  aigc_text2sql_syntax_fixes: 'Syntax Fixes',
  aigc_text2sql_syntax_retry_fixes: 'Please try to fix the syntax issue',
  aigc_text2sql_syntax_issue: 'Trying to fix the syntax issue...',
  aigc_text2sql_syntax_completed: 'Automatic fix completed.',
  aigc_text2sql_syntax_check_passed: 'TBDS SQL syntax check passed.',

  // 空文本
  aigc_text2sql_empty: 'Automatically select the relevant table based on your question.',

  aigc_text2sql_no_data: 'No relevant tables were found for the question.',
  aigc_text2sql_modal_is_ok: 'Are you sure to delete this table?',
  aigc_text2sql_modal_main_desc: 'This action cannot be undone. Are you sure to delete this table?',

  aigc_text2sql_operational_one_title: 'Input The Task',
  aigc_text2sql_operational_one_content_first: 'Clearly describe your tasks and send to Text2SQL.',
  aigc_text2sql_operational_two_title: 'Confirm relevant table',
  aigc_text2sql_operational_two_content_first: `After waiting for the system to select the table based on the task,`,
  aigc_text2sql_operational_two_content_second: `please edit and confirm that the selected table is correct.(待优化)`,
  aigc_text2sql_operational_three_title: 'Optimize SQL',
  aigc_text2sql_operational_three_content_first: 'Please wait for the system to generate SQL statements based on',
  aigc_text2sql_operational_three_content_second: 'the task and the selected table, and then optimize the code using,',
  aigc_text2sql_operational_three_content_last_message: 'the dialogue or editor.',
};
